export * from "./isValidEmail";
export * from "./isValidHttpUrl";
export * from "./isValidIsoDate";

export type ComponentSize = "lg" | "md" | "sm";

export const makeTextStyles = (isDisabled: boolean, size: ComponentSize) =>
	({
		"text-sm": size === "sm" || size === "md",
		"text-primary": !isDisabled,
		"text-primary-disabled": isDisabled,
	}) as const;

export const makePointerStyles = (isDisabled: boolean) => ({
	"cursor-pointer": !isDisabled,
	"cursor-not-allowed": isDisabled,
});
